const ENV = {
  modulePrefix: "results",
  environment: import.meta.env.DEV ? "development" : "production",
  rootURL: "/",
  locationType: "history",
  EmberENV: {
    EXTEND_PROTOTYPES: false,
    FEATURES: {},
  },
  APP: {},
} as {
  environment: string;
  locationType: "history" | "hash" | "none";
  rootURL: string;
  APP: Record<string, unknown>;
};

export default ENV;

export function enterTestMode() {
  ENV.locationType = "none";
  ENV.APP.rootElement = "#ember-testing";
  ENV.APP.autoboot = false;
}
